export default __webpack_public_path__ + "static/media/location-pin.a17b6b21.svg";